export default () => ({
  usuarioslista: null,
  usuariosinfo: null,
});
